(function () {
    'use strict';

    angular
        .module('app')
        .directive('errorlist', errorlist);

    errorlist.$inject = ['$window'];

    function errorlist($window) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                errorListDialogShown: '=?'
            },
            controller: 'errorList',
            templateUrl: 'app/errorlist/errorlist.html'
        };
        return directive;

        function link(scope, element, attrs) {



        }

    }

})();